import React, { Component } from 'react'
import { Input } from 'hljd'
import { SearchBar } from 'hljd'
import { inject } from 'mobx-react'

const Item = SearchBar.Item

@inject('store')
export default class extends Component {
  render() {
    const { store, ...rest } = this.props

    return (
      <SearchBar store={store} {...rest}>
        <Item label="成员" name="name">
          <Input placeholder="请输入成员称呼" />
        </Item>
      </SearchBar>
    )
  }
}
